import { useIntl } from "react-intl";

import { queries } from "lib/build/dashboards/htx/queries";
import { Origin } from "lib/build/events";

import { useLastEventByQuery } from "src/features/events";

export function useHeight(): {
	value: string;
	timestamp?: string;
	origin?: Origin;
} {
	const { formatNumber } = useIntl();
	const event = useLastEventByQuery<number>(queries.height);
	return event === undefined
		? { value: "-" }
		: {
				value: `${formatNumber(event.value)} cm`,
				timestamp: event.timestamp,
				origin: event.origin
			};
}
